import {useDispatch, useSelector} from "react-redux";
import layoutActions from "@pillvery/redux/layout/actions";
import {useEffect, useState} from "react";


export default function SettingsWrapper() {
    const dispatch = useDispatch();
    const { isSettingsOpen } = useSelector(state => state.Layout )
    const [openClass, setOpenClass] = useState();

    useEffect(() =>{
        if(isSettingsOpen){
            setOpenClass("open")
        }else{
            setOpenClass(null);
        }
    }, [isSettingsOpen])

    function handleToggle() {
        dispatch(layoutActions.toggleSettings())
    }

    return (
        <div className="theme-setting-wrapper">
            {/*<div id="settings-trigger" onClick={ handleToggle }>*/}
            {/*    <i className="mdi mdi-settings"></i>*/}
            {/*</div>*/}

            {/*<div id="theme-settings" className={"settings-panel " + openClass}>*/}

            {/*    <i className="settings-close mdi mdi-close" onClick={ handleToggle }></i>*/}

            {/*    <p className="settings-heading">SIDEBAR SKINS</p>*/}
            {/*    <div className="sidebar-bg-options selected" id="sidebar-light-theme">*/}
            {/*        <div className="img-ss rounded-circle bg-light border mr-3"></div>*/}
            {/*        Light*/}
            {/*    </div>*/}
            {/*    <div className="sidebar-bg-options" id="sidebar-dark-theme">*/}
            {/*        <div className="img-ss rounded-circle bg-dark border mr-3"></div>*/}
            {/*        Dark*/}
            {/*    </div>*/}
            {/*    <p className="settings-heading mt-2">HEADER SKINS</p>*/}
            {/*    <div className="color-tiles mx-0 px-4">*/}
            {/*        <div className="tiles success"></div>*/}
            {/*        <div className="tiles warning"></div>*/}
            {/*        <div className="tiles danger"></div>*/}
            {/*        <div className="tiles info"></div>*/}
            {/*        <div className="tiles dark"></div>*/}
            {/*        <div className="tiles default"></div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    )
}